import type { ReactElement } from 'react'
import { Monitor, Server, Laptop } from 'lucide-react'

export function getDeviceIcon(deviceType: string | null): ReactElement {
  if (!deviceType) return <Monitor className="h-4 w-4 text-slate-400" />
  const type = deviceType.toLowerCase()
  if (type.includes('server')) return <Server className="h-4 w-4 text-blue-500" />
  if (type.includes('workstation') || type.includes('laptop'))
    return <Laptop className="h-4 w-4 text-green-500" />
  return <Monitor className="h-4 w-4 text-slate-400" />
}
